// extracted by mini-css-extract-plugin
module.exports = {"heading":"hero-heading-module--heading--2aNRO","noMaxWidth":"hero-heading-module--noMaxWidth--2tm0G","smallerInMobile":"hero-heading-module--smallerInMobile--1bIzm"};